import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import { useUserRole } from "../partner-access/hooks/usePartnerAccess"
import { MemberOnlySpaceNotice } from "#/components/partner-access/member-only-space-notice"
import { FILL_REMAINING_SPACE } from "#/features/global-ui/page-layout"

const EmployeeOnlySpaceContainer = ({ fillHeight = false, ...props }): JSX.Element => {
  const { isPartnerAccessingAccount, isUserRoleLoading } = useUserRole()

  if (isUserRoleLoading) {
    return null
  }

  if (isPartnerAccessingAccount) {
    return <MemberOnlySpaceNotice />
  }

  // `fillHeight` OPT-IN, default off, because this wrapper sits in the middle of `PageLayout`'s
  // `fillViewport` chain and a styleless `<div>` breaks it. A flex item with no styles is
  // `flex: 0 1 auto` with `min-height: auto`, so it takes its CONTENT's height — and then the
  // `minmax(0, 1fr)` grid below it has nothing finite to divide and every `flex: 1` beneath is inert.
  //
  // MEASURED in Chrome, not reasoned: with this div unstyled, a 40-message thread grew the messages grid
  // to 2692px against a 1103px viewport and put the composer at 2780–2860 — clipped by the `100dvh`
  // box's `overflow: hidden` and unreachable, so the member could not reply at all. With these four
  // declarations: grid 935px, composer at 1023–1103, on screen, and the thread scrolling in its own box.
  // Reproduction in the ticket.
  //
  // It cannot be fixed from below. A percentage or a `flex: 1` inside a content-height parent resolves
  // against nothing, so no amount of care in the messages layout can compensate.
  //
  // Opt-in rather than always-on: the other eleven call sites render into pages that grow and scroll the
  // document, which is what they should keep doing. Only a page that has asked `PageLayout` for
  // `fillViewport` wants this.
  if (fillHeight) {
    return <Box sx={FILL_REMAINING_SPACE}>{props.children}</Box>
  }

  return <div>{props.children}</div>
}

export default EmployeeOnlySpaceContainer
